export const DOWNLOAD_FILES_AS_ZIP_REQUEST = 'DOWNLOAD_FILES_AS_ZIP_REQUEST';

export const downloadFilesAsZipRequest = () => ({
    type: DOWNLOAD_FILES_AS_ZIP_REQUEST,
});
